import { styled } from "@/stitches.config";

export const Div = styled("div");
export const Span = styled("span");
export const Button = styled("button", {
  cursor: "pointer",
  border: "none",
});
